// js/models/tree_select.ts (well, now it’s down with ReactTreeSelect)
declare type DropDownBook = any;
declare type DropDownCategory = any;

// TODO: drop these
var defaultCategoryIdPlaceholder;
var defaultExternalCategoryId;

var showNumbersOfSelectedItems = false;


class DropDownSelect2 extends DropDownSelect {
    private bookIdList: Array<number>;
    private categoryIdList: Array<number>;
    private books: IDropDownBookDictionary;
    private categories: IDropDownCategoryDictionary;
    private rootCategory: DropDownCategory;
    private selectedChangedCallback: (state: State) => void;
    private restoreCategoryIds: Array<number>;
    private restoreBookIds: Array<number>;
    private descriptionDiv: HTMLDivElement;
    private cancelDiv: HTMLDivElement;
    private isLoaded: boolean;
    private favoriteBook: FavoriteBook;
    private bookType: BookTypeEnum;
    private overrideSelectedBookCountVal: number;

    private _cachedResponse: IDropDownRequestResult;
    private _restoreExternalCategoryIds: Array<string>;

    private static selectedBookUrlKey = "selectedBookIds";
    private static selectedCategoryUrlKey = "selectedCategoryIds";

    // private static stringIdsPerArea;
    // static initialize() { // looks like it needs to be called explicitly...
    // }

    // private stringIdsPerArea: object;
    private stringIdsPerArea: {
        [area in BookTypeEnum]?:
        {
            [stringId: string]: string
        }
    };

    // XXX: use the type in stringIdsPerArea; share what is common, don't copy
    private stringIds: {
        [stringId: string]: string
    };

    private localizationScope = "PluginsJs";
    private getStringOrFallback: CallableFunction; // or just Function?

    constructor(
        dropDownSelectContainer: string,
        dataUrl: string,
        bookType: BookTypeEnum,
        showStar: boolean,
        callbackDelegate: DropDownSelectCallbackDelegate,
        props?: {
            extraCssClasses: string[];
            enableFilter: boolean;
            enableLegacyImplementation: boolean;
            openDropdownAtStart: boolean;
        },
    ) {
        super(
            dropDownSelectContainer,
            dataUrl,
            showStar,
            callbackDelegate,
            props,
        );

        this.bookType = bookType;
        //  XXX: why?
        this.selectedChangedCallback = callbackDelegate.selectedChangedCallback;
        callbackDelegate.selectedChangedCallback = null;

        callbackDelegate.getRootCategoryCallback = (categories) => {
            return this.rootCategory.id;
        };
        callbackDelegate.getCategoryIdCallback = (category) => {
            return String(this.categories[category].id);
        };
        callbackDelegate.getCategoryTextCallback = (category) => {
            return this.categories[category].name;
        };
        callbackDelegate.getChildCategoriesCallback = (categories, currentCategory) => {
            return this.categories[currentCategory].subcategoryIds;
        };
        callbackDelegate.getChildLeafItemsCallback = (items, currentCategory) => {
            return this.categories[currentCategory].bookIds;
        };
        callbackDelegate.getLeafItemIdCallback = (item) => {
            return String(this.books[item].id);
        };
        callbackDelegate.getLeafItemTextCallback = (item) => {
            return this.books[item].name;
        };
        this.isLoaded = false;
        this.overrideSelectedBookCountVal = null;

        // https://stackoverflow.com/questions/54438012/an-index-signature-parameter-type-cannot-be-a-union-type-consider-using-a-mappe
        this.stringIdsPerArea = {
            [BookTypeEnum.Dictionary]: {
                'SearchBooks': 'DictionariesToSearchIn',
                'AllBooks': 'AllDictionaries', // XXX: the fallback (AllBooks) should only be temporary and removed once all "areas/modules" have a specialization
            },
            [BookTypeEnum.Edition]: {
                'SearchBooks': 'EditionsToSearchIn',
                'AllBooks': 'AllEditions',
            },
        };

        this.stringIds = this.stringIdsPerArea[this.bookType];
        this.getStringOrFallback = getStringOrFallbackExtension.bind(this); // .../js/itjakub.ts
    }

    makeAndRestore(
        categoryIds: Array<number>, bookIds: Array<number>,
        externalCategoryIds?: Array<string>)
    {
        this.restoreCategoryIds = categoryIds;
        this.restoreBookIds = bookIds;

        // Stable/defined textual IDs instead of unstable/arbitrary numeric ones.
        // This is a means of pre-selecting modern dictionaries during an initial load.
        this._restoreExternalCategoryIds = externalCategoryIds;

        this.makeDropdown();

        // Translate the default ID (-1) rather to a category name.
        if (categoryIds && categoryIds.length == 1 &&
            categoryIds[0] == defaultCategoryIdPlaceholder
        ) {
            categoryIds = [];
            externalCategoryIds = [defaultExternalCategoryId];
        }

        // @ts-ignore
        this._newSelector.setSelected({
            bookIds,
            categoryIds,
            externalCategoryIds,
        });
    }

    makeDropdown() {
        // this.isLoaded = false;
        super.makeDropdown();

        if (!this._enableLegacyImplementation)
            return;

        this.descriptionDiv = document.createElement("div");
        $(this.descriptionDiv).addClass("dropdown-description");
        $(this.dropDownSelectContainer).append(this.descriptionDiv);

        this.cancelDiv = document.createElement("div");
        $(this.cancelDiv).addClass("dropdown-cancel");
        $(this.dropDownSelectContainer).append(this.cancelDiv);

        if (this.showStar) {
            var cancelButton = this.createCancelButton();
            $(this.cancelDiv).append(cancelButton);

            var favoriteDropdownDiv = document.createElement("div");
            this.favoriteBook = new FavoriteBook(favoriteDropdownDiv, this.bookType, this);
            this.favoriteBook.make();

            $(this.dropDownSelectContainer).append(favoriteDropdownDiv);
        }

        // XXX: we need to call updateSelectionInfo again because descriptionDiv
        // is replaced here just after super.makeDropdown (which already called
        // doRestore but its work was partially thrown away...)
        if (this.isLoaded)
            this.doRestore();
    }

    private createCancelButton(): HTMLElement {
        const elem = $(`<a href="#" class="btn btn-sm btn-default" title="${localization.translate("CancelBookFilter", "PluginsJs").value}"><span class="glyphicon glyphicon-remove"></span></a>`);
        elem.click(() => {
            this.favoriteBook.resetSelected();
        });
        return elem.get(0);
    }

    //  XXX: only used in FavoriteBook (currently disabled)
    setSelected(categoryIds: Array<number>, bookIds: Array<number>) {
        if (categoryIds.length === 0 && bookIds.length === 0) {
            this.rootCategory.checkBox.checked = false;
            this.rootCategory.checkBox.indeterminate = false;
        }
        $("input[type=checkbox]", this.dropDownBodyDiv).prop("checked", false);
        this.restore(categoryIds, bookIds);
    }

    // NOTE: certainly called from _enableOtherModernDictionaries
    restore(categoryIds: Array<number>, bookIds: Array<number>) {
        this.restoreCategoryIds = categoryIds;
        this.restoreBookIds = bookIds;

        this.doRestore();

        // @ts-ignore
        this._newSelector.setSelected({
            bookIds,
            categoryIds,
        });
    }

    protected onFavoritesChanged(favoriteType: FavoriteType, id: number): void {
        this.favoriteBook.loadData();
        new NewFavoriteNotification().show();
    }

    private doRestore()
    {
        // XXX: this function is mostly additive and seems to assume that (works best if)
        //      no groups or items are currently selected -- which is wrong
        // XXX: hopefully there is some cleanup / "uncheck all" function ==> makeAndRestore?
        // XXX: in the future, virtual DOM approach (React.js) should greatly
        //      simplify and "de-bug" this
        var categoriesCount = 0;
        var booksCount = 0;

        // Translate/lookup “textual” group IDs in(to) restoreCategoryIds.
        // This enables selection of modern dictionaries on load (if no selection has been made yet).
        if (this._restoreExternalCategoryIds) {
            for (let externalCategoryName of this._restoreExternalCategoryIds) {
                for (let categoryId in this.categories) { // XXX: iterate
                    let category = this.categories[categoryId];
                    let categoryIdAsNumber = Number(categoryId);

                    if (category.externalId === externalCategoryName) {
                        if (this.restoreCategoryIds.indexOf(categoryIdAsNumber) === -1)
                            this.restoreCategoryIds.push(categoryIdAsNumber);
                    }
                }
            }
        }

        if (this.restoreCategoryIds) {
            for (var i = 0; i < this.restoreCategoryIds.length; i++) {
                var category = this.categories[this.restoreCategoryIds[i]];
                if (!category) {
                    continue;
                }
                category.checkBox.checked = true;
                category.checkBox.indeterminate = false; // XXX: this is a fix (ESSČ => all modern) but let's see what propagateSelectChange is supposed to do... well, not this so we're fine
                this.propagateSelectChange($(category.checkBox).parent(".concrete-item")[0] as Node as HTMLDivElement);
                // NOTE: this calls openCloseCategory
                $(category.moreSpan).trigger('click');
                categoriesCount++;
            }
        }

        if (this.restoreBookIds) {
            for (var j = 0; j < this.restoreBookIds.length; j++) {
                var book = this.books[this.restoreBookIds[j]];
                if (!book) {
                    continue;
                }

                for (var k = 0; k < book.checkboxes.length; k++) {
                    var checkbox = book.checkboxes[k];
                    if (checkbox.checked)
                        continue;

                    checkbox.checked = true;
                    this.propagateSelectChange($(checkbox).parent(".concrete-item")[0] as Node as HTMLDivElement);
                }
            }
            booksCount = this.getSelectedBookCount();
        }

        if (showNumbersOfSelectedItems)
        this.updateSelectionInfo(categoriesCount, booksCount);
    }

    protected downloadData(dropDownItemsDiv: HTMLDivElement) {
        this.books = {};

        var loadDiv = lv.create(null, "lv-circles lv-mid sm lvb-1 lvt-1");
        $(dropDownItemsDiv).append(loadDiv.getElement());

        if (this.isLoaded) {
            this._dataDownloaded('cached', dropDownItemsDiv, loadDiv);
            return;
        }

        $.ajax({
            type: "GET",
            traditional: true,
            data: {},
            url: this.dataUrl,
            dataType: "json",
            contentType: "application/json",
            success: (response) => this._dataDownloaded(
                response, dropDownItemsDiv, loadDiv),
            error: () => {
                $(dropDownItemsDiv).children("div.lv-circles").remove();
                $(dropDownItemsDiv).siblings(".dropdown-select-header").children("div.lv-circles").remove();
                const selectHeader = $(dropDownItemsDiv).parent().children(".dropdown-select-header");
                $(selectHeader).children(".dropdown-select-text").append(localization.translate("LoadingContentError", "PluginsJs").value);
                this.isLoaded = true;
                this.dataLoaded(null);
                this.downloadFavoriteData(dropDownItemsDiv);
            }
        });
    }

    private _dataDownloaded(
        response: IDropDownRequestResult | 'cached',
        dropDownItemsDiv: HTMLDivElement, loadDiv: lv.ElementBase)
    {
        if (response === 'cached')
            response = this._cachedResponse;
        else
            this._cachedResponse = response;

        if (this._enableLegacyImplementation)
        loadDiv.remove();

        this.processDownloadedData(response);

        // if (this._enableLegacyImplementation)
        this.makeTreeStructure(this.categories, this.books, dropDownItemsDiv);

        // TODO: drop this whole awful imperative implementation as soon as possible,
        //       it is a nightmare to work with
        if (this._enableLegacyImplementation)
        this.rootCategory.checkBox = ($(dropDownItemsDiv).parent().children(".dropdown-select-header").children("span.dropdown-select-checkbox").children("input").get(0) as Node as HTMLInputElement);
        else {
            this.rootCategory.checkBox = {
                checked: false,
                indeterminate: false,
            };
        }

        if (this._enableLegacyImplementation)
        this.doRestore();
        this.isLoaded = true;

        this.dataLoaded(this.rootCategory.id);
        this.showBody();

        if (this._enableLegacyImplementation)
        this.downloadFavoriteData(dropDownItemsDiv);

        // check/select and open the modern dictionaries category
        // @ts-ignore
        this._newSelector.patchData(response);

        // @ts-ignore
        this._newSelector.sendMessage('gotData', {
            response,
        });
    }

    public downloadFavoriteData(dropDownItemsDiv: HTMLDivElement): void {
        if (!this.showStar) {
            return;
        }

        var loadedFavoriteCategories: Array<IDropdownFavoriteItem> = null;
        var loadedFavoriteBooks: Array<IDropdownFavoriteItem> = null;
        var loadedFavoriteLabels: Array<IFavoriteLabel> = null;

        var isAllLoaded = () => (loadedFavoriteCategories != null &&
            loadedFavoriteBooks != null &&
            loadedFavoriteLabels != null);

        this.favoriteManager.getFavoritesForCategories(this.categoryIdList, (favoriteCategories) => {
            loadedFavoriteCategories = favoriteCategories;

            if (isAllLoaded()) {
                this.updateFavoriteIcons(loadedFavoriteCategories, loadedFavoriteBooks, loadedFavoriteLabels, dropDownItemsDiv);
            }
        });

        this.favoriteManager.getFavoritesForBooks(null, this.bookIdList, (favoriteBooks) => {
            loadedFavoriteBooks = favoriteBooks;

            if (isAllLoaded()) {
                this.updateFavoriteIcons(loadedFavoriteCategories, loadedFavoriteBooks, loadedFavoriteLabels, dropDownItemsDiv);
            }
        });

        this.favoriteManager.getLatestFavoriteLabels(favoriteLabels => {
            loadedFavoriteLabels = favoriteLabels;

            if (isAllLoaded()) {
                this.updateFavoriteIcons(loadedFavoriteCategories, loadedFavoriteBooks, loadedFavoriteLabels, dropDownItemsDiv);
            }
        });
    }

    private processDownloadedData(result: IDropDownRequestResult) {
        this.books = {};
        this.categories = {};
        this.bookIdList = [];
        this.categoryIdList = [];

        for (let i = 0; i < result.categories.length; i++) {
            let resultCategory = result.categories[i];
            // @ts-ignore
            var category = new DropDownCategory();
            category.id = resultCategory.id;
            category.name = resultCategory.description;
            category.externalId = resultCategory.externalId;
            category.parentCategoryId = resultCategory.parentCategoryId;
            category.bookIds = [];
            category.subcategoryIds = [];
            this.categories[category.id] = category;
            this.categoryIdList.push(category.id);

            if (category.parentCategoryId == null)
                this.rootCategory = category;
        }

        for (let i = 0; i < result.categories.length; i++) {
            let resultCategory = result.categories[i];
            if (resultCategory.parentCategoryId == null)
                continue;

            var parentCategory = this.categories[resultCategory.parentCategoryId];
            parentCategory.subcategoryIds.push(resultCategory.id);
        }

        for (var j = 0; j < result.books.length; j++) {
            var resultBook = result.books[j];
            // @ts-ignore
            var book = new DropDownBook();
            book.id = resultBook.id;
            book.name = resultBook.title;
            book.linkingAbbreviation = resultBook.linkingAbbreviation;
            book.sourceAbbreviation = resultBook.sourceAbbreviation;
            book.categoryIds = resultBook.categoryIds;
            book.checkboxes = [];
            this.books[book.id] = book;
            this.bookIdList.push(book.id);

            for (var k = 0; k < book.categoryIds.length; k++) {
                var categoryId = book.categoryIds[k];
                if (this.categories[categoryId])
                    this.categories[categoryId].bookIds.push(book.id);
            }
        }
    }

    //  XXX: `id` is actually a `number` but see IDropDownBookDictionary (`string`)
    // NOTE: I chose a bad name originally (getItemById)
    public getBookById(id: number): DropDownBook
    {
        return this.books[id]; // `String(id)` would be exact but JS has type coercion
    }

    public getCategoryById(id: number): DropDownCategory
    {
        return this.categories[id];
    }

    protected makeLeafItem(container: HTMLDivElement, currentLeafItem: any) {
        if (this._enableLegacyImplementation) {

        var itemDiv = document.createElement("div");
        $(itemDiv).addClass("concrete-item"); //TODO add data-item-is-favorite

        } // enableLegacyImplementation

        const book = this.books[currentLeafItem];
        let checkbox = null;

        if (this._enableLegacyImplementation) {

        $(itemDiv).data("id", this.books[currentLeafItem].id);
        $(itemDiv).data("name", this.books[currentLeafItem].name);
        $(itemDiv).data("type", "item");

        checkbox = document.createElement("input");
        $(checkbox).addClass("concrete-item-checkbox checkbox");
        checkbox.type = "checkbox";

        } else { // !enableLegacyImplementation
            checkbox = {
                checked: false,
            };
        }

        this.books[currentLeafItem].checkboxes.push(checkbox);

        if (!this._enableLegacyImplementation)
            return;

        // selectUnselectBook
        var info = this.createCallbackInfo(String(this.books[currentLeafItem].id), this.books[currentLeafItem].name, itemDiv);
        $(checkbox).change((event: JQuery.Event, propagate: boolean) => {
            const selected = checkbox.checked;

            if (selected) {
                this.addToSelectedItems(info);
            } else {
                this.removeFromSelectedItems(info);
            }

            //  XXX: propagateSelectChange checks and unchecks books in affected
            //       categories!
            // NOTE: a genuine event (though still from jQuery) also carries an
            //       originalEvent
            // @ts-ignore
            if (!event.isTrigger) {
                // @ts-ignore
                this._newSelector.sendMessage('selectUnselectBook', {
                    bookId: book.id,
                    selected,
                });
            }

            if (typeof propagate === "undefined" || propagate === null || propagate) { //Deafault behaviour is to propagate change
                this.propagateSelectChange($(checkbox).parent(".concrete-item")[0] as Node as HTMLDivElement);
                this.propagateLeafSelectChange(checkbox, info);
            }
        });

        itemDiv.appendChild(checkbox);

        if (this.showStar) {
            var favoriteStarContainer = document.createElement("span");
            $(favoriteStarContainer).addClass("save-item");

            itemDiv.appendChild(favoriteStarContainer);
        }

        var nameSpan = document.createElement("span");
        $(nameSpan).addClass("concrete-item-name");
        nameSpan.innerHTML = this.books[currentLeafItem].name;

        itemDiv.appendChild(nameSpan);

        container.appendChild(itemDiv);
    }

    /*
     XXX: the number of selected “books” and categories is no longer desired,
          we rather prefer the drop-down selection to change to a collapsible
          element, open at the start
     XXX: so yeah, this should some day be renamed from DropDownSelect2 to
          something else – or even, be replaced with a component based on
          react-bootstrap
    */
    private updateSelectionInfo(categoriesCount: number, booksCount: number) {
        var categoriesCountString = String(categoriesCount);
        var booksCountString = String(booksCount);

        if (!this.rootCategory.checkBox.indeterminate) {
            categoriesCountString = localization.translate("All1", "PluginsJs").value;
            booksCountString = this.getStringOrFallback("AllBooks");
        }

        if (this.overrideSelectedBookCountVal != null) {
            booksCountString = this.overrideSelectedBookCountVal.toString();
        }

        var infoDiv = document.createElement("div");
        var infoText = localization.translate("SearchCategories", "PluginsJs").value + categoriesCountString + "<br>"
            + this.getStringOrFallback("SearchBooks") + booksCountString;

        infoDiv.innerHTML = infoText;

        $(this.descriptionDiv).empty();
        $(this.descriptionDiv).append(infoDiv);
    }

    private getSelectedBookCount(): number {
        var count = 0;
        for (var i = 0; i < this.bookIdList.length; i++) {
            var bookId = this.bookIdList[i];
            var firstCheckBox = this.books[bookId].checkboxes[0];

            // XXX: "Dodavky" was imported twice (probably with two different UUIDs);
            //      id=5 has no categories and no checkboxes, id=15 has one of each
            if (firstCheckBox === undefined)
                continue;

            if (firstCheckBox.checked)
                count++;
        }
        return count;
    }

    protected onCreateCategoryCheckBox(
        categoryId: string,
        checkBox: HTMLInputElement,
        moreSpan: HTMLSpanElement,
        childsDiv: HTMLDivElement,
    ) {
        const category = this.categories[categoryId];

        category.checkBox = checkBox;
        category.moreSpan = moreSpan;
        category.childsDiv = childsDiv;
    }

    private onSelectionChanged() {
        var currentState = this.getState();
        var categoriesCount = currentState.SelectedCategories.length;
        var booksCount = this.getSelectedBookCount();

        this.selectedChangedCallback(currentState);

        if (showNumbersOfSelectedItems)
        this.updateSelectionInfo(categoriesCount, booksCount);
    }

    protected propagateRootSelectChange(item: HTMLInputElement) {
        this.onSelectionChanged();
    }

    protected propagateLeafSelectChange(item: HTMLInputElement, info: CallbackInfo) {
        var sameBookCheckBoxes = this.books[info.ItemId].checkboxes;
        var checkBoxState = $(item).prop("checked");
        for (var i = 0; i < sameBookCheckBoxes.length; i++) {
            var otherCheckBox = sameBookCheckBoxes[i];
            if ($(otherCheckBox).prop("checked") !== checkBoxState) {
                $(otherCheckBox).prop("checked", checkBoxState);
                this.propagateSelectChange($(otherCheckBox).parent(".concrete-item")[0] as Node as HTMLDivElement);
            }
        }

        this.onSelectionChanged();
    }

    protected propagateCategorySelectChange(item: HTMLInputElement, info: CallbackInfo) {
        var isChecked = $(item).prop("checked");
        var category = this.categories[info.ItemId];
        var bookIds: Array<number> = [];

        this.getBookIdsForUpdate(category, bookIds);

        for (var i = 0; i < bookIds.length; i++) {
            var book = this.books[bookIds[i]];

            for (var j = 0; j < book.checkboxes.length; j++) {
                var bookCheckBox = book.checkboxes[j];
                if ($(bookCheckBox).prop("checked") !== isChecked) {
                    $(bookCheckBox).prop("checked", isChecked);
                    this.propagateSelectChange($(bookCheckBox).parent(".concrete-item")[0] as Node as HTMLDivElement);
                }
            }
        }

        this.onSelectionChanged();
    }

    private getBookIdsForUpdate(category: DropDownCategory, bookIds: Array<number>) {
        for (var i = 0; i < category.bookIds.length; i++) {
            var bookId = category.bookIds[i];
            if ($.inArray(bookId, bookIds) === -1) {
                bookIds.push(bookId);
            }
        }
        for (var j = 0; j < category.subcategoryIds.length; j++) {
            var subcategoryId = category.subcategoryIds[j];
            var subcategory = this.categories[subcategoryId];
            this.getBookIdsForUpdate(subcategory, bookIds);
        }
    }

    private getSelected(category: DropDownCategory, selectedCategories: Array<number>, selectedBooks: Array<number>) {
        if (!category.checkBox.indeterminate) {
            if (category.checkBox.checked) {
                selectedCategories.push(category.id);
            }
            return;
        }

        for (var i = 0; i < category.subcategoryIds.length; i++) {
            var subcategory = this.categories[category.subcategoryIds[i]];
            this.getSelected(subcategory, selectedCategories, selectedBooks);
        }

        for (var j = 0; j < category.bookIds.length; j++) {
            var book = this.books[category.bookIds[j]];
            if (book.checkboxes[0].checked)
                selectedBooks.push(book.id);
        }
    }

    getState(): State {
        var selectedIds = this.getSelectedIds();
        var state = new State();
        state.SelectedCategories = [];
        state.SelectedItems = [];
        state.IsOnlyRootSelected = selectedIds.isOnlyRootSelected;

        for (let i = 0; i < selectedIds.selectedCategoryIds.length; i++) {
            let id = selectedIds.selectedCategoryIds[i];
            state.SelectedCategories.push(new Category(String(id), this.categories[id].name));
        }
        for (let i = 0; i < selectedIds.selectedBookIds.length; i++) {
            let id = selectedIds.selectedBookIds[i];
            state.SelectedItems.push(new Item(String(id), this.books[id].name));
        }

        return state;
    }

    getSelectedIds(): DropDownSelected {
        var state = new DropDownSelected({});
        var selectedBooks = [];
        var selectedCategories = [];
        if (!this.rootCategory || !this.rootCategory.checkBox.indeterminate) {
            if (this.rootCategory) {
                state.selectedCategoryIds.push(this.rootCategory.id);
            }
        } else {
            this.getSelected(this.rootCategory, selectedCategories, selectedBooks);
            state.selectedBookIds = selectedBooks;
            state.selectedCategoryIds = selectedCategories;
            state.isOnlyRootSelected = false;
        }

        return state;
    }

    isDataLoaded(): boolean {
        return this.isLoaded;
    }

    static getUrlStringFromState(state: State): string {
        // DONE: typeahead needs this (thus – restored)

        var selectedBooks = state.SelectedItems;
        var selectedCategories = state.SelectedCategories;
        var resultString = "";

        for (let i = 0; i < selectedBooks.length; i++) {
            if (resultString.length > 0)
                resultString += "&";
            resultString += DropDownSelect2.selectedBookUrlKey + "=" + selectedBooks[i].Id;
        }

        for (let i = 0; i < selectedCategories.length; i++) {
            if (resultString.length > 0)
                resultString += "&";
            resultString += DropDownSelect2.selectedCategoryUrlKey + "=" + selectedCategories[i].Id;
        }

        return resultString;
    }

    getSerializedState(): string {
        var state = this.getSelectedIds();
        return JSON.stringify(state);
    }

    //  XXX: not sure we still use the consumers…
    restoreFromSerializedState(serializedState: string) {
        var state: DropDownSelected = JSON.parse(serializedState);
        this.restore(state.selectedCategoryIds, state.selectedBookIds);
    }

    getFavoriteBookComponent(): FavoriteBook {
        return this.favoriteBook;
    }

    overrideSelectedBookCount(newCount: number) {
        this.overrideSelectedBookCountVal = newCount;
    }

    hasBooksLoaded(): boolean {
        return this.bookIdList && this.bookIdList.length > 0;
    }
}

class DropDownSelected
{
    selectedBookIds: Array<number>;
    selectedCategoryIds: Array<number>;
    isOnlyRootSelected: boolean;

    constructor({
        isOnlyRootSelected = true,
        selectedBookIds = null,
        selectedCategoryIds = null,
    }: {
        isOnlyRootSelected?: boolean,
        selectedBookIds?: Array<number>;
        selectedCategoryIds?: Array<number>;
    })
    {
        this.selectedBookIds = selectedBookIds ?? [];
        this.selectedCategoryIds = selectedCategoryIds ?? [];
        this.isOnlyRootSelected = isOnlyRootSelected;
    }
}


interface IDropDownBookDictionary {
    [bookId: string]: DropDownBook;
}

interface IDropDownCategoryDictionary {
    [categoryId: string]: DropDownCategory;
}
